export default __webpack_public_path__ + "static/media/VapidWhichAnole-max-1mb.c052dff4.gif";